// 评论管理
import http from "@/jslibs/axios/http";

// 评论列表
export const list = (data) => http.get("/v1/cms/GoodsComment", data);

// 评论状态
export const status = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsComment/status/${uuid}`, data);

// 评论上下架
export const sj = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsComment/sj/${uuid}`, data);

// 评论置顶
export const top = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsComment/top/${uuid}`, data);

// 评论回复
export const reply = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsComment/reply/${uuid}`, data);

// 评论详情
export const detail = ({ uuid }) => http.get(`/v1/cms/GoodsComment/${uuid}`);

// 评论删除
export const del = ({ uuid }) => http.delete(`/v1/cms/GoodsComment/${uuid}`);
